import { MouseEventHandler } from "react";
import { Button } from "@bca/ui-library";

import FilterSolidSVG from "../icons/FilterSolidSVG";
import { ViewportSizeType } from "../hooks/useViewport.hook";

const ToggleFiltersButton: React.FunctionComponent<{
  showFilters: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  ref?: any;
  viewportWidth: ViewportSizeType;
}> = ({ showFilters, onClick, ref, viewportWidth }) => {
  if (viewportWidth !== "desktop" && showFilters) {
    return null;
  }
  const buttonText = viewportWidth !== "desktop" ? "Filters" : "Show Filters";

  return (
    <Button
      width={viewportWidth !== "desktop" ? "94px" : "141px"}
      height="auto"
      paddingX={3}
      paddingY={3}
      text={showFilters ? "Hide Filters" : buttonText}
      ref={ref}
      variant="button"
      onClick={onClick}
      css={`
        flex-direction: row-reverse;
      `}
      data-en="click"
      data-ec="button"
      data-el="filter"
      data-es=""
      data-ea={showFilters ? "hide" : "show"}
    >
      <FilterSolidSVG width="14px" height="14px" mr={2} />
    </Button>
  );
};

export default ToggleFiltersButton;
